import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { CreateAccountChargifyV2 } from '../../containers/account/CreateAccountV2';

export const AdminAccountCreateChargifyPage = () => {
	return (
		<AdminDashboardPageLayout>
			<CreateAccountChargifyV2 />
		</AdminDashboardPageLayout>
	);
};
